module.exports = __webpack_public_path__ + "img/bvd.1641520899224.png";